import React, { useEffect, useState } from "react";
import Logo from "./Logo";

const CoupleDashboardHeader = ({ couple, onShare, onLogout }) => {
    const [mobileOpen, setMobileOpen] = useState(false);

    // (opcional) bloquear scroll cuando está abierto
    useEffect(() => {
        document.body.style.overflow = mobileOpen ? "hidden" : "";
        return () => {
            document.body.style.overflow = "";
        };
    }, [mobileOpen]);

    return (
        <>
            <header className="bg-white border-b border-neutral-200 sticky top-0 z-40">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
                    {/* ================= DESKTOP (igual al original) ================= */}
                    <div className="hidden sm:flex items-center justify-between gap-6">
                        {/* Left */}
                        <div>
                            <Logo className="h-9 sm:h-10" />
                            <h1 className="text-2xl font-display font-bold text-neutral-900 mt-2">
                                Panel de {couple.brideName} &amp; {couple.groomName}
                            </h1>
                        </div>

                        {/* Right */}
                        <div className="flex items-center gap-5 text-sm sm:text-base">
                            <a
                                href={`/lista/${couple.id}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-neutral-600 hover:text-accent-600 font-medium transition-colors"
                            >
                                Ver mi lista
                            </a>

                            <div className="h-6 w-px bg-neutral-200" />

                            <button
                                onClick={onShare}
                                className="bg-accent-500 text-white px-4 py-2 rounded-lg font-semibold hover:bg-accent-600 transition-colors"
                            >
                                Compartir
                            </button>

                            <button
                                onClick={onLogout}
                                className="text-neutral-500 hover:text-neutral-800 transition-colors"
                            >
                                Cerrar sesión
                            </button>
                        </div>
                    </div>

                  
                  {/* ================= MOBILE ================= */}
<div className="sm:hidden">
  <div className="flex items-center justify-between gap-3">
    <div className="min-w-0">
      {/* Logo más protagonista */}
      <Logo className="h-11 w-auto" />

      {/* Subtítulo compacto */}
      <p className="mt-1 text-sm text-neutral-600 truncate">
        Panel de {couple.brideName} &amp; {couple.groomName}
      </p>
    </div>

    <button
      type="button"
      aria-label="Menu"
      aria-expanded={mobileOpen}
      onClick={() => setMobileOpen((v) => !v)}
      className="shrink-0 text-neutral-700 p-2 rounded-lg hover:bg-neutral-50 border border-neutral-200"
    >
      <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
      </svg>
    </button>
  </div>
</div>

                </div>
            </header>

            {/* ================= MOBILE OVERLAY MENU ================= */}
            {mobileOpen && (
                <div className="sm:hidden fixed inset-0 z-50">
                    {/* Backdrop */}
                    <button
                        type="button"
                        aria-label="Cerrar menu"
                        onClick={() => setMobileOpen(false)}
                        className="absolute inset-0 bg-black/40"
                    />

                    {/* Panel */}
                    <div className="absolute top-0 left-0 right-0 bg-white shadow-xl border-b border-neutral-200">
                        <div className="max-w-7xl mx-auto px-4 py-4">
                            <div className="px-0">
                                <div className="flex items-center justify-between">
                                    <Logo className="h-11 w-auto shrink-0" />
                                    <button
                                        type="button"
                                        aria-label="Cerrar"
                                        onClick={() => setMobileOpen(false)}
                                        className="text-neutral-700 p-2 rounded-lg hover:bg-neutral-50 border border-neutral-200"
                                    >
                                        ✕
                                    </button>
                                </div>

                                <div className="mt-4 space-y-1 pb-1">
                                    <a
                                        href={`/lista/${couple.id}`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        onClick={() => setMobileOpen(false)}
                                        className="flex items-center justify-between rounded-xl px-4 py-3 text-neutral-800 hover:bg-neutral-50"
                                    >
                                        <span className="font-medium">Ver mi lista</span>
                                        <span className="text-neutral-400">↗</span>
                                    </a>

                                    <button
                                        onClick={() => {
                                            setMobileOpen(false);
                                            onShare();
                                        }}
                                        className="flex w-full items-center justify-between rounded-xl px-4 py-3 text-neutral-800 hover:bg-neutral-50"
                                    >
                                        <span className="font-medium">Compartí tu lista</span>
                                        <span className="text-neutral-400">⤴</span>
                                    </button>

                                    <button
                                        onClick={() => {
                                            setMobileOpen(false);
                                            onLogout();
                                        }}
                                        className="flex w-full items-center justify-between rounded-xl px-4 py-3 text-red-600 hover:bg-red-50"
                                    >
                                        <span className="font-medium">Cerrar sesión</span>
                                        <span className="text-red-300">⟶</span>
                                    </button>
                                </div>

                            </div>
                            {/* <p className="text-xs text-neutral-500 pt-2 border-t border-neutral-200">
                                Tip: podés compartir tu link directo desde “Compartir”.
                            </p> */}
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default CoupleDashboardHeader;
